import { SxProps } from "@mui/material";

export const cardSx = (selected: boolean): SxProps => ({
  borderRadius: "6px",
  border: `1px solid ${selected ? "#0055A4" : "#E4E7EC"}`,
  boxShadow: selected ? "0 0 0 3px rgba(0,85,164,0.12)" : "none",
  p: 1.5,
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: selected ? "#0055A4" : "#D0D5DD",
  },
  backgroundColor: "#FFFFFF",
});

export const labelSx = (selected: boolean): SxProps => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "22px",
  lineHeight: "24px",
  color: "#0055A4",
});

export const subtitleSx: SxProps = {
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#667085",
};

import { commonStyles } from "../../tokens";
export const backButtonSx: SxProps = commonStyles.backButton;

export const nextButtonSx: SxProps = {
  height: 40,
  borderRadius: "6px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
};
